<button
  [ngStyle]="{
    'text-align': initOptions.textAlign,
    width: '100%',
    height: initOptions.height + 'px'
  }"
  class="button {{ initOptions.style }}">
  {{ initOptions.inner_text }}
</button>
